'use client';

import { ReactNode } from 'react';
import { cn } from '@/app/lib';

type MegaMenuContainerProps = {
  children: ReactNode;
  className?: string;
  isClosing?: boolean;
};

export const MegaMenuContainer = ({ children, className, isClosing = false }: MegaMenuContainerProps) => {
  return (
    <div
      className={cn(
        'fixed inset-x-0 top-21.25 bg-white/98 z-50 border-b border-secondary-100 overflow-y-auto overscroll-y-contain [-webkit-overflow-scrolling:touch] [touch-action:pan-y]',
        isClosing ? 'animate-fadeOut' : 'animate-fadeIn',
        className,
      )}
      role="region"
      aria-label="Sub menu"
    >
      {children}
    </div>
  );
};
